import React from "react";

export default function renderIcon({
  width = 16,
  height = 16,
  color = "#4B1E78",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 8 V3 H8" />
      <path d="M21 8 V3 H16" />
      <path d="M3 16 V21 H8" />
      <path d="M21 16 V21 H16" />
    </svg>
  );
}
